let isDev = process.env.NODE_ENV === "development";
const URLS = {
  ARBITER_BASE_PATH: isDev ? "/multipay" : "/portal/multipay",
  ARBITER_API_BASE_PATH: "/api/v1",
  ARBITER_API_TRANSACTIONS: "/transactions",
  ARBITER_API_TRANSACTION_TYPES: "/transactions/types",
  ARBITER_API_TRANSACTION_TYPE: "/transaction-types",
  ARBITER_API_TRANSACTIONS_STORES: "/transactions/stores",
  ARBITER_API_TRANSACTION_GROUPS: "/transaction-groups",
  ARBITER_API_TRANSACTIONS_GROUPS: "/transactions/groups",
  ARBITER_API_TRANSACTION_TIMELINES: "/transaction-timelines",

  ARBITER_API_SCRIPTS: "/scripts",

  ARBITER_API_SETTLEMENT_REQUESTS: "/settlements/requests",
  ARBITER_API_SETTLEMENT_REQUEST_STATUSES: "/settlements/requests/statuses",
  ARBITER_API_SETTLEMENT: "/settlements",

  ARBITER_API_DISPUTES: "/disputes",
  ARBITER_API_DISPUTES_BULK: "disputes/bulk/disputes",
  ARBITER_API_DISPUTES_BULK_ACCEPT_OR_DECLINE: "disputes/bulk",
  ARBITER_API_DISPUTES_BATCHES: "/disputes/batches",
  ARBITER_API_DISPUTE_TIMELINES: "/dispute-timelines",
  ARBITER_API_REASON_CODES: "/reason-codes",
  ARBITER_API_DISPUTE_REGIONS: "/dispute-regions",
  ARBITER_API_DISPUTES_CATEGORIES: "/disputes/categories",
  ARBITER_API_DISPUTES_CATEGORIES_BULK: "/disputes/bulk/categories",
  ARBITER_API_DOWNLOAD_TEMPLATE: "/batches/templates",
  ARBITER_API_DOWNLOAD_ERROR_FILE: "/batches/files",
  ARBITER_API_DISPUTES_ACQUIRERS: "disputes/acquirers",
  ARBITER_API_DISPUTES_ISSUERS: "disputes/issuers",
  ARBITER_API_DISPUTES_MERCHANTS: "disputes/merchants",
  ARBITER_API_BULK_ACCEPT: "disputes/bulkUpdates",

  ARBITER_API_MERCHANT_DISPUTANTS: "/merchant-disputants",

  ARBITER_API_SETTINGS_CONFIG: "/settings",
  ARBITER_API_SETTINGS_CONFIG_BY_TYPE: "/settings/type",
  ARBITER_API_SETTINGS_CONFIG_TYPES: "/settings/types/all",

  ARBITER_API_GET_COUNTRIES: "dispute-regions/countries",

  USER_API_USER_PERMISSIONS: "/user/permissions",
  USER_API: "/user",

  VERIFICATION_API: "/verification",
  VERIFICATION_MAKERS: "/verification/makers",
  VERIFICATION_CHECKERS: "verification/checkers",

  ARBITER_API_SETTLEMENT_RULES: "/settlement-rules",
  ARBITER_API_GET_SETTLEMENT_RULES_LABEL: "settlement-rules/labels",

  ARBITER_API_SETTLEMENT_REPORTS: "/settlements/reports",
  ARBITER_API_SETTLEMENT_REPORTS_FILES: "/files",
  ARBITER_PUBLIC_FOLDER_URL: "https://mufasa.interswitchng.com/p/arbiter-api/help",
  ISW_CUSTOMER_PORTAL_URL: "https://help.interswitchgroup.com",
  
  ARBITER_API_DISCOVER_TRANSACTIONS: "/dnds/transactions",
  ARBITER_API_DISCOVER_REASONCODES: "/dnds/cases/reasons",
  ARBITER_API_DISCOVER_CASES: "/dnds/cases",

  REPORTS: "/reports",
  REPORT: (reportType) => {
    return `${reportType}/reports`
  }
};
export default URLS;


// WEBPACK FOOTER //
// ./src/configurations/urls.js